"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.BannerMedia = void 0;
require("./BannerMedia.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _actionFormatter = require("../../util/actionFormatter/actionFormatter");
var _getButtonHtml = require("../../util/getButtonHtml/getButtonHtml");
var _getLinkHtml = require("../../util/getLinkHtml/getLinkHtml");
var _renderObject = require("../../util/renderObject/renderObject");
var _BannerBody = _interopRequireDefault(require("../BannerBody/BannerBody"));
var _BannerFooter = _interopRequireDefault(require("../BannerFooter/BannerFooter"));
var _BannerHeader = _interopRequireDefault(require("../BannerHeader/BannerHeader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * BannerMedia component
 *
 * @method
 * @param { BannerMediaProps} props
 * @returns BannerMedia
 */

const BannerMedia = props => {
  const {
    actionGroups,
    body,
    bulletedList,
    externalAction,
    externalActionFullyClick,
    externalMedia,
    eyebrow,
    fullyClickableParent,
    headline,
    headlineTag = defaultProps.headlineTag,
    backgroundMedia,
    tag,
    textColor = defaultProps.textColor,
    textPosition = defaultProps.textPosition
  } = props;

  /** Object for full click */
  let formattedActionFullyClick;

  /** Image and Text checks for header and body */
  const hasImage = backgroundMedia || externalMedia;
  const hasText = actionGroups || body || eyebrow || headline || tag;

  /** Text variables */
  const isKnockoutLink = textColor === 'content-knockout';
  let updatedTextPosition = textPosition.toLowerCase(); // Update the text position from DXL to be all lowerCase
  const textAlignment = updatedTextPosition === 'center-center' || updatedTextPosition === 'center' ? 'center' : 'left';

  /** Action check for formatters */
  const paletteOneAction = actionGroups && actionGroups.actions?.length === 1;
  const hasOneAction = fullyClickableParent || paletteOneAction;
  const fullyClickAction = actionGroups && actionGroups.actions[0];
  const fullyClickType = actionGroups && actionGroups.types;
  if (paletteOneAction) {
    formattedActionFullyClick = (0, _actionFormatter.actionFormatter)({
      action: fullyClickAction,
      types: fullyClickType,
      derivedAriaLabel: actionGroups?.actions[0].label,
      hasOneAction: hasOneAction,
      fullyClickableParent: paletteOneAction
    }, {
      getButtonMarkup: _getButtonHtml.getButtonHtml,
      getLinkMarkup: _getLinkHtml.getLinkHtml
    });
  }
  const componentClassName = (0, _classnames.default)('pal-c-BannerMedia', {
    [`pal-c-BannerMedia__contentAlign--${updatedTextPosition}`]: updatedTextPosition,
    [`pal-c-BannerMedia--oneAction`]: hasOneAction
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, hasOneAction && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, formattedActionFullyClick && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _renderObject.renderObject)(formattedActionFullyClick)), externalActionFullyClick && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _renderObject.renderObject)(externalActionFullyClick))), hasImage && /*#__PURE__*/_react.default.createElement(_BannerHeader.default, {
    externalMedia: externalMedia,
    backgroundMedia: {
      desktopImage: backgroundMedia?.image,
      tabletImage: backgroundMedia?.tabletImage,
      mobileImage: backgroundMedia?.mobileImage,
      altText: backgroundMedia?.altText,
      loading: backgroundMedia?.loading
    }
  }), hasText && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-BannerMedia__mainContainer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-BannerMedia__bodyAndAction"
  }, /*#__PURE__*/_react.default.createElement(_BannerBody.default, {
    tag: tag,
    eyebrow: eyebrow,
    headline: headline,
    headlineTag: headlineTag,
    headlineStyle: "headline-lg",
    body: body,
    bodyStyle: "body-lg",
    bulletedList: bulletedList,
    textAlignment: textAlignment,
    textPosition: updatedTextPosition,
    textColor: textColor
  }), /*#__PURE__*/_react.default.createElement(_BannerFooter.default, _extends({}, actionGroups, {
    externalAction: externalAction,
    isKnockoutLink: isKnockoutLink,
    textAlignment: textAlignment
  })))));
};

/**
 * Property type definitions
 * @typedef BannerMediaProps
 * @type {object}
 * @property {object} actionGroups - Allows passing an object to the actionGroup prop
 * @property {object} backgroundMedia - desktopImage, tabletImage, mobileImage, type, altText, ratio and loading prop for Image component
 * @property {string} body - body text/description of the hero body
 * @property {array} bulletedList - array of bulleted list items
 * @property {object} externalAction - external action object
 * @property {object} externalMedia - brings in the UltaAsset
 * @property {string} eyebrow - smaller text above the headline
 * @property {string} headline - headline text of the hero body
 * @property {string} headlineTag - headline tag of the hero body
 * @property {object} tag - tag component above the eyebrow
 * @property {string} textColor - sets the color of the text to default or knockout
 * @property {string} textPosition - aligns the content to 'top-left', 'center-left', 'bottom-left', 'center', or 'right'
 */
exports.BannerMedia = BannerMedia;
const propTypes = exports.propTypes = {
  /**
   * Allows passing an object to the actionGroups prop
   */
  actionGroups: _propTypes.default.object,
  /**
   * desktopImage, tabletImage, mobileImage, type, altText, ratio and loading prop for Image component
   */
  backgroundMedia: _propTypes.default.object,
  /**
   * body text/description of the hero body
   */
  body: _propTypes.default.string,
  /**
   * array of bulleted list items
   */
  bulletedList: _propTypes.default.array,
  /**
   * Sets the primary action from an external source that contains business logic
   */
  externalAction: _propTypes.default.object,
  /**
   * Brings in the UltaAsset
   */
  externalImage: _propTypes.default.object,
  /**
   * Smaller text above the headline
   */
  eyebrow: _propTypes.default.string,
  /**
   * headline text of the hero body
   */
  headline: _propTypes.default.string,
  /**
   * HTML tag for the headline
   */
  headlineTag: _propTypes.default.string,
  /**
   * tag component above the eyebrow
   */
  tag: _propTypes.default.object,
  /**
   * Sets the color of the text to default or knockout
   */
  textColor: _propTypes.default.oneOf(['content-default', 'content-knockout']),
  /**
   * Aligns the content to left or center
   */
  textPosition: _propTypes.default.oneOf(['top-left', 'center-left', 'bottom-Left', 'center', 'right'])
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} headlineTag - headlineTag: 'h2' - sets the default for the headline tag
 * @property {string} textColor - textColor: 'content-default'- sets the color of the text to content-default or content-knockout
 * @property {string} textPosition - textPosition='top-left'' - The default textPosition setting
 */
const defaultProps = exports.defaultProps = {
  headlineTag: 'h2',
  textColor: 'content-default',
  textPosition: 'top-left'
};
BannerMedia.propTypes = propTypes;
var _default = exports.default = BannerMedia;